<template>
  <div class="form">
     <ui-input
       :type="'email'"
       :placeholder="t('fields.email')"
       :rules="[isEmail]"
       v-model="email"
     />
    <ui-button
        class="form__button"
        :isLoading="isLoading"
        :isDisabled="!isFormValid"
        @click="resetPassword"
    >
      {{ t('buttons.reset') }}
    </ui-button>
  </div>
</template>

<script setup>
import UiInput from "@/components/ui/ui-input.vue";
import {useI18n} from "vue-i18n";
import {isEmail} from "@/core/rules/textFieldRules.js";
import {computed, ref} from "vue";
import UiButton from "@/components/ui/ui-button.vue";
import {Auth} from "@/core/api/auth.js";
import {ElNotification} from "element-plus";

const {t} = useI18n()

const email = ref('')

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
    isEmail(email.value) === true
  )
})

const resetPassword = async () => {
  const res = await Auth.resetPassword(email.value);

  ElNotification({
    message: t('popup.reset')
  })
}
</script>

<style lang="scss" scoped>
.form {
  position: relative;
  z-index: 1;
  width: 585px;
  display: flex;
  flex-direction: column;
  gap: 45px;

  &__block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;

    & p {
      color: #5B194F;
      font-size: 16px;
      font-weight: 600;
    }
  }

  &__button {
    width: fit-content;
    padding-inline: 50px;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 7px;

    &-link {
      transition: 0.2s;
      color: #FFCF96;
      font-size: 14px;
      font-weight: 500;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;

      &:hover {
        color: #fcb86d;
      }
    }

    &-text {
      transition: 0.2s;
      color: #6C6C6C;
      font-size: 14px;
      font-weight: 400;

      &:hover {
      color: #333333;
      }
    }
  }
}

@media (max-width: 650px) {
  .form {
    width: 100%;
  }
}
</style>